<template>
  <v-layout row fill-height id="homepage" class="home-page">
    <v-flex xs8 id="home-list-all">
      <v-layout wrap class="pt-4">
        <v-flex xs12>
          <v-form @submit.prevent="searchExaminations">
            <v-layout wrap>
              <v-flex xs3 class="pl-4 pr-2">
                <v-menu
                  v-model="seachFromMenu"
                  :close-on-content-click="false"
                  full-width
                  max-width="290"
                >
                  <v-text-field
                    slot="activator"
                    :value="computedFromDate"
                    :label="$t('homepage.from')"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="searchFromDate"
                    @change="seachFromMenu = false"
                    no-title
                    :max="searchToDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs3 class="px-2">
                <v-menu
                  v-model="seachToMenu"
                  :close-on-content-click="false"
                  full-width
                  max-width="290"
                >
                  <v-text-field
                    slot="activator"
                    :value="computedToDate"
                    :label="$t('homepage.to')"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="searchToDate"
                    @change="seachToMenu = false"
                    no-title
                    :min="searchFromDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs3 class="pl-2 pr-4">
                <v-text-field
                  v-model="searchExaminationRecords"
                  :label="$t('homepage.examination_records')"
                  flat
                  hide-details
                />
              </v-flex>

              <v-flex xs3 class="pl-2 pr-4">
                <v-text-field
                  v-model="seachMedicalRecords"
                  :label="$t('homepage.medical_records')"
                  flat
                  hide-details
                  :rules="xssRules"
                ></v-text-field>
              </v-flex>

              <v-flex id="search-btn-container" xs12>
                <v-btn
                  type="submit"
                  round
                  color="primary"
                  dark
                  @submit.prevent="search"
                  >{{$t('homepage.search')}}</v-btn
                >
                <v-btn
                  type="button"
                  round
                  color="primary"
                  dark
                  @click="fetchTodayExaminationsList()"
                  >{{$t('homepage.today')}}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>

        <v-layout row justify-space-between class="pt-4 px-4">
          <h1 class="headline font-weight-light">{{$t('homepage.examinations')}}</h1>
          <div class="d-flex" style="align-items: center;">
            <!-- 國健署匯出功能：由醫院配置的 nhia_export feature flag 控制顯示 -->
            <template v-if="getHospitalFeatures.nhia_export">
              <v-radio-group
                v-model="exportReportType"
                name="exportReportType"
                row
                hide-details
                class="pt-0 mt-0 justify-end"
              >
                <v-radio label="Report" value="upload" />
                <v-radio label="Delete" value="delete" />
              </v-radio-group>
              <v-btn
                type="button"
                round
                color="success"
                dark
                @click="exportReports"
                >國健署匯出</v-btn
              >
            </template>
            <v-btn
              :disabled="disabledSyncWorklist"
              type="submit"
              round
              color="primary"
              @click="handleWorklistSync"
            >
                {{ syncWorklistText }}
              </v-btn
            >
          </div>
        </v-layout>
        <v-flex xs12 fill-height>
          <template>
            <v-data-table
              :headers="headers"
              :items="getExaminations"
              :search="search"
              class="ma-4"
              item-key="id"
              :rows-per-page-items="rowsPerPages"
              :rows-per-page-text="$t('homepage.rows_per_page')"
              :no-data-text="$t('homepage.no_data_available')"
              :pagination.sync="paginationNumber"
            >
              <template slot="items" slot-scope="props">
                <tr 
                  :class="{ active: selectedExamination === props.item.url }" 
                  @click="goToPage(props.item.url); selectExamination(props.item.url)"
                >
                  <!-- 國健署匯出勾選框：僅在 nhia_export 開啟時顯示 -->
                  <td
                    v-if="getHospitalFeatures.nhia_export"
                    class="fz-20 font-weight-bold"
                    @click.stop="()=>{}"
                  >
                    <v-checkbox
                      :input-value="selectedExaminations.includes(props.item.id)"
                      @change="selectExaminationAccno(props.item.id)"
                      class="m-0 p-0 d-flex align-center exam-table-checkbox"
                      :ripple="false"
                    ></v-checkbox>
                  </td>
                  <td class="fz-20 font-weight-bold">{{ props.item.date.replace(/\//g, "-") }}</td>
                  <td class="fz-20 font-weight-bold">{{ props.item.accNo }}</td>
                  <td :class="['fz-20', 'font-weight-bold', getColor(props.item.examination_typeID)]">{{ examinationType(props.item.examination_typeID) }}</td>
                  <td class="fz-20 font-weight-bold">{{ props.item.patientName }}</td>
                  <td class="fz-20 font-weight-bold">{{ props.item.medicalRecord }}</td>
                  <td class="fz-20 font-weight-bold" :style="{ 'background-color': statusColor(props.item.examinationStatus)}">{{ examinationStatus(props.item.examinationStatus)}}</td>
                  <!-- ONLY FOR ZSCMH
                  <td class="fz-20 font-weight-bold">{{ reportStatus(props.item.reportStatus) }}</td>
                  <td>
                    <v-btn
                      :loading="loading5"
                      :disabled="loading5"
                      class="ma-2 black--text"
                      @click="searchExaminations2()"
                    >
                      {{ props.item.reportShippingStatus || "TODO" }}
                      <v-icon color="info"> cached </v-icon>
                    </v-btn>
                    <br />
                    {{ timeToUTC8(props.item.reportShippingTime) }}
                  </td>
                  <td>
                    <v-btn
                      class="ma-2 black--text"
                      @click="
                        selectExamination(props.item.url);
                        editDialog = true;
                      "
                    >
                      <label>傳送至新單號</label>
                      <v-icon color="info"> near_me </v-icon>
                    </v-btn>
                    <br />
                    {{ timeToUTC8(props.item.reportShippingTime) }}
                  </td>
                  -->
                </tr>
              </template>
            </v-data-table>
            <v-dialog
              v-if="editDialog"
              v-model="editDialog"
              persistent
              max-width="500px"
            >
              <v-card>
                <v-card-text>
                  <v-container>
                    <div>
                      <div cols="6">
                        <span>院內碼:</span
                        ><span>{{
                          selectedExaminationInfo.hospitalCode || ""
                        }}</span>
                      </div>
                    </div>
                    <div>
                      <div cols="6">
                        <span>日期:</span
                        ><span>{{
                          selectedExaminationInfo.examinationDate | Date
                        }}</span>
                      </div>
                    </div>
                    <div>
                      <div cols="6">
                        <span>病患姓名:</span
                        ><span>{{ selectedExaminationInfo.patientName }}</span>
                      </div>
                    </div>
                    <div>
                      <div cols="6">
                        <span>病歷號碼:</span
                        ><span>{{
                          selectedExaminationInfo.medicalRecord
                        }}</span>
                      </div>
                    </div>
                    <div>
                      <div cols="6">
                        <span>檢查單號:</span
                        ><span>{{
                          selectedExaminationInfo.examinationRecord
                        }}</span>
                      </div>
                    </div>
                    <div align="center">
                      <div cols="6">
                        <v-text-field
                          v-model="newAccNo"
                          filled
                          label="新檢查單號"
                          clearable
                        ></v-text-field>
                      </div>
                    </div>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="darken-2" text @click="editDialog = false">
                    Cancel
                  </v-btn>

                  <v-btn
                    color="darken-2"
                    text
                    @click="reportShippingToNewAccNo()"
                  >
                    Send
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-if="transferLoading"
              v-model="transferLoading"
              hide-overlay
              persistent
              width="300"
            >
              <v-card color="primary" dark>
                <v-card-text>
                  報告轉送中
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog
              v-if="notifyDialog"
              v-model="notifyDialog"
              max-width="290"
            >
              <v-card>
                <v-card-title class="text-h3"> 報告轉送結果 </v-card-title>

                <v-card-text>
                  {{ transferResultMessage }}
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="darken-1" text @click="initialNotifyMessage()">
                    知道了
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs4 id="home-list-detail">
      <router-view />
    </v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";
import { get } from "lodash";
import { mapGetters, mapActions } from "vuex";
import { reportServices } from "@/services/db";
import { iShareHubRequest } from "@/services/iShareHub";
import { subscribeExaminationFinished } from "@/utils/examination-finished-channel";

const DISABLE_SYNC_SEC = 5

export default {
  data() {
    return {
      paginationNumber: {},
      exportReportType: 'upload',
      selectedExaminations: [],
      newAccNo: "",
      loading5: false,
      transferLoading: false,
      notifyDialog: false,
      transferResultMessage: "",
      editDialog: false,
      disabledSyncWorklist: false,
      syncWorklistCount: 0,
      syncWorklistTimer: 0,

      selectedExaminationInfo: {
        medicalRecord: "",
        examinationRecord: "",
        hospitalCode: "",
        patientName: "",
        examinationDate: "",
      },
      search: "",
      rowsPerPages: [10, 20, { text: this.$t('homepage.rows_per_page'), value: -1 }],
      selectedExamination: null,
      seachFromMenu: false,
      searchFromDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().slice(0, 10),
      seachToMenu: false,
      searchToDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().slice(0, 10),
      seachMedicalRecords: "",
      searchExaminationRecords: "",
      reportStatusList: ["Unedited", "Editing", "Finalized"],
      xssRules: [
        (value) => {
          if (this.seachMedicalRecords == null) {
            return (this.seachMedicalRecords = "");
          } else {
            let xssFilter = new RegExp(
              /(\b)(on\S+)(\s*)=|javascript|(<\s*)(\/*)script/gi
            );
            this.seachMedicalRecords = this.seachMedicalRecords.replace(
              /[&><%^&"]/g,
              ""
            );
            this.seachMedicalRecords = xssFilter.test(this.seachMedicalRecords)
              ? (this.seachMedicalRecords = "")
              : this.seachMedicalRecords;
            return true;
          }
        },
      ],
    };
  },

  created() {
    window.onkeydown = function (e) {}
    window.onkeyup = function (e) {}
    this.fetchExaminationsList({
      from: this.searchFromDate,
      to: this.searchToDate,
      medicalRecord: this.seachMedicalRecords,
      examinationRecord: this.searchExaminationRecords,
    })
    // KAN-9：訂閱「檢查已結束」跨頁 / 跨分頁通知 → 依當前搜尋條件重抓待看清單。
    // 檢查頁與 Home 是頂層互斥路由、無 keep-alive，同分頁「結束→返回 Home」靠上面的
    // created() refetch（前提是 Webrtc 已 await status 落地）；此訂閱負責「Home 長駐 / 另一分頁」場景。
    this._unsubscribeExaminationFinished = subscribeExaminationFinished(() => {
      this.searchExaminations()
    })
  },

  beforeDestroy() {
    if (this._unsubscribeExaminationFinished) {
      this._unsubscribeExaminationFinished()
      this._unsubscribeExaminationFinished = null
    }
  },

  computed: {
    ...mapGetters(['getHospitalFeatures']),
    ...mapGetters("examinations", ["getExaminations"]),

    computedFromDate() {
      return this.searchFromDate
        ? moment(this.searchFromDate).format("MM-DD-YYYY")
        : "";
    },

    computedToDate() {
      return this.searchToDate
        ? moment(this.searchToDate).format("MM-DD-YYYY")
        : "";
    },

    syncWorklistText() {
      return this.disabledSyncWorklist
        ? `TRY AGAIN ${this.syncWorklistCount}s`
        : this.$t('homepage.sync_worklist')
    },

    headers() {
      return [
        // 國健署匯出欄位：僅在 nhia_export 開啟時顯示 checkbox 列
        ...(this.getHospitalFeatures.nhia_export ? [{
          text: 'Export Item',
          align: "left",
          value: "",
        }] : []),
        {
          text: this.$t('homepage.date'),
          align: "left",
          value: "date",
        },
        {
          text: this.$t('homepage.examination_record'),
          align: "left",
          value: "accNo",
        },
        {
          text: this.$t('homepage.examination_type'),
          align: "left",
          value: "examination_typeID",
        },
        {
          text: this.$t('homepage.patient_name'),
          align: "left",
          value: "patientName",
        },
        {
          text: this.$t('homepage.medical_record'),
          align: "left",
          value: "medicalRecord",
        },
        {
          text: this.$t('homepage.status'),
          align: "left",
          value: "examinationStatus",
        },
        /* ONLY FOR ZSCMH
        {
          text: "Report Status",
          align: "left",
          value: "reportStatus",
        },
        {
          text: "Report Shipping Status",
          align: "left",
          value: "reportShippingStatus",
        },
        {
          text: "Report Re-Shipping with AccNo",
          align: "left",
          value: "transferAccNo",
        },
        */
      ]
    },
    examinationTypesList() {
      return ["", this.$t('homepage.gastroscopy'), this.$t('homepage.colonoscopy'), this.$t('homepage.sigmoidoscopy')]
    },
    examinationStatusList() {
      return [this.$t('homepage.unfinished'), "Executing", this.$t('homepage.finished')]
    },
  },

  methods: {
    ...mapActions("examinations", [
      "fetchExaminationsList",
      "fetchNewExaminationsList",
    ]),
    selectExaminationAccno(accNo) {
      if (this.selectedExaminations.includes(accNo)) {
        this.selectedExaminations = this.selectedExaminations.filter((item) => item !== accNo)
      } else {
        this.selectedExaminations.push(accNo)
      }
    },
    async downloadReport(reportData){
      const data = reportData.data
      if(!data.content){
        this.$store.dispatch('snackbar/showSnackbar', { text: 'No data available!', color: 'error' })
        return
      }
      // 使用 atob 將 base64 轉 binary 字串
      const binaryString = atob(data.content);

      // 將 binary 字串轉成 Uint8Array
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // 用 TextDecoder 解碼 UTF-8
      const decoder = new TextDecoder('utf-8');
      const decodedContent = decoder.decode(bytes);
      // 建立 blob 並下載
      const blob = new Blob([decodedContent], { type: 'text/xml' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = data.filename || 'report.xml';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    async exportReports() {
      if(this.selectedExaminations.length === 0) {
        this.$store.dispatch('snackBar/trigger', {
          message: '請選擇至少一個檢查',
          color: 'error', // 或 error/info/warning
          timeout: 3000
        })
        return
      }
      try{
        const res = await iShareHubRequest({reportType: this.exportReportType, examId: this.selectedExaminations, validateOnly: false})
        // console.log(res)
        if(!res.success){
          this.$store.dispatch('snackBar/trigger', {
            message: res.message,
            color: 'error', // 或 error/info/warning
            timeout: 3000
          })
          return
        }
        this.downloadReport(res)
      } catch (error) {
        console.log(error)
        this.$store.dispatch('snackBar/trigger', { 
          message: 'Failed to export report', 
          color: 'error',
          timeout: 3000
        })
      }
    },
    goToPage(page) {
      this.$router.replace({ path: `/home/${page}` });
    },

    async selectExamination(id) {
      this.selectedExamination = id;
      const row = await this.selectedRow(id);
      this.selectedExaminationInfo.examinationRecord = row[0].accNo;
      this.selectedExaminationInfo.medicalRecord = row[0].medicalRecord;
      this.selectedExaminationInfo.examinationDate = row[0].date;
      this.selectedExaminationInfo.patientName = row[0].patientName;
      this.selectedExaminationInfo.hospitalCode = row[0].hospitalCode;
    },

    fetchTodayExaminationsList() {
      this.searchFromDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().slice(0, 10);
      this.searchToDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().slice(0, 10);
      this.seachMedicalRecords = "";
      let condition = {
        from: this.searchFromDate,
        to: this.searchToDate,
        medicalRecord: this.seachMedicalRecords,
        examinationRecord: this.searchExaminationRecords,
      };
      this.fetchExaminationsList(condition);
      this.$forceUpdate();
    },
    searchExaminations() {
      let condition = {
        from: this.searchFromDate,
        to: this.searchToDate,
        medicalRecord: this.seachMedicalRecords,
        examinationRecord: this.searchExaminationRecords,
      };
      this.fetchExaminationsList(condition);
      this.$forceUpdate();
      this.selectedExaminations = [];
    },
    searchExaminations2() {
      this.loading5 = true;
      let condition = {
        from: this.searchFromDate,
        to: this.searchToDate,
        medicalRecord: this.seachMedicalRecords,
        examinationRecord: this.searchExaminationRecords,
      };
      this.fetchExaminationsList(condition);
      this.$forceUpdate();
      this.loading5 = false;
      this.selectedExaminations = [];
    },
    examinationType(number) {
      return this.examinationTypesList[number];
    },
    examinationStatus(number) {
      return this.examinationStatusList[number];
    },
    reportStatus(number) {
      return this.reportStatusList[number];
    },
    statusColor(number) {
      let condition = this.examinationStatusList[number];
      return condition === "Finished" ? "#FFC49BCC" : null;
    },
    timeToUTC8(dt) {
      let t = dt ? moment(dt).format("YYYY-MM-DD HH:mm:ss") : dt;
      return t;
    },
    getColor(type_id) {
      switch (type_id) {
        case 1:
          return 'color--gastroscopy'
        case 2:
        case 3:
          return 'color--colonoscopy'
        default:
          return ''
      }
    },
    async selectedRow(id) {
      return this.getExaminations.filter((d) => {
        return d.url == id;
      });
    },
    async reportShippingToNewAccNo() {
      this.editDialog = false;
      this.transferResultMessage = "";
      if (this.newAccNo.trim() !== "") {
        this.transferLoading = true;
        const res = await reportServices.transferToNewAccNo({
          patientId: this.selectedExaminationInfo.medicalRecord,
          accNo: this.selectedExaminationInfo.examinationRecord,
          newAccNo: this.newAccNo,
        });
        this.transferResultMessage = get(res, 'data.message', '') || '';
        this.transferLoading = false;
        this.notifyDialog = true;
      }
    },
    initialNotifyMessage() {
      this.notifyDialog = false;
      this.newAccNo = "";
    },
    countdown() {
      clearInterval(this.syncWorklistTimer)
      this.disabledSyncWorklist = true
      this.syncWorklistCount = DISABLE_SYNC_SEC

      this.syncWorklistTimer = setInterval(() => {
        if (this.syncWorklistCount > 0) {
          this.syncWorklistCount -= 1
        } else {
          this.syncWorklistCount = 0
          this.disabledSyncWorklist = false
        }
      }, 1000)
    },
    handleWorklistSync() {
      if (!this.disabledSyncWorklist) {
        this.fetchNewExaminationsList().then(this.countdown)
      }
    },
  },
  watch: {
    paginationNumber(newVal, oldVal) {
      console.log('watch paginationNumber')
      this.$set(this, 'selectedExaminations', [])
    },
    async getExaminations(newVal, oldVal) {
      await this.$nextTick()
      console.log('watch getExaminations')
      this.$set(this, 'selectedExaminations', [])
    }
  }
};
</script>

<style lang="scss" scoped>
#homepage {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;

  h1 {
    font-size: 20px !important;
  }

  h4 {
    font-size: 18px !important;
  }
}

#home-list-all {
  overflow: auto;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

#home-list-detail {
  overflow-y: auto;
}

.search-container {
  :deep()
    .v-text-field.v-text-field--enclosed
    > .v-input__control
    > .v-input__slot {
    padding: 0;
  }

  :deep() .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: transparent;
  }
}

#search-btn-container {
  position: relative;
  text-align: center;

  &:after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.12);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  :deep(.v-btn) {
    z-index: 1;
    padding-left: 28px;
    padding-right: 28px;
  }
}

.headline {
  padding-top: 10px;
}

.color--colonoscopy {
  color: $defaultOrange;
}

.color--gastroscopy {
  color: $defaultBlue;
}
.exam-table-checkbox {
  :deep(.v-messages) {
    display: none;
  }
}
</style>

<style lang="scss">
tr.active,
.theme--light.v-table tbody tr.active:hover:not(.v-datatable__expand-row) {
  background: #d6d6d6;
}

.fz-20 {
  font-size: 20px !important;
}
</style>
